import { render, staticRenderFns } from "./newMaterialNoResult.vue?vue&type=template&id=139a05f2&scoped=true&"
import script from "./newMaterialNoResult.vue?vue&type=script&lang=js&"
export * from "./newMaterialNoResult.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialNoResult.vue?vue&type=style&index=0&id=139a05f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139a05f2",
  null
  
)

component.options.__file = "newMaterialNoResult.vue"
export default component.exports